import BulkEditButton from 'components/BulkEditButton/BulkEditButton';
import ConceptSearchBar from 'components/Searchbar/UnconstrainedForecastSearchBar';
import CircularProgress from 'components/circularProgress';
import UploadExcelButton from 'components/UploadExcelButton/UploadExcelButton';
import Navbar from 'components/navbar';
import { useStore } from 'hooks/useStore';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import BulkUpdate from 'screens/FDPScreen/components/UnconstraintForecastScreen/components/BulkUpdate';
import UploadExcelModal from 'screens/FDPScreen/components/UnconstraintForecastScreen/components/UploadExcel/UploadExcel';
import UploadExcelValidation from 'screens/FDPScreen/components/UnconstraintForecastScreen/components/UploadExcelValidation/UploadExcelValidation';

const UnconstraintForecastHoc = () => {
  const {
    UnconstrainedForecastViewStore: {
      percentProgress,
      isUnconstrainedForecastProgressLoading,
      toggleBulkUpdateModal,
      uploadModalOpen,
      uploadValidationModalOpen,
      toggleUploadModal,
      toggleUploadValidationModal,
      resetStore: resetViewStore,
    },
    UnconstrainedForecastEditStore: { resetStore: resetEditStore },
  } = useStore();

  useEffect(() => {
    // Cleanup function will be called when component unmounts
    return () => {
      resetViewStore();
      resetEditStore();
    };
  }, [resetViewStore, resetEditStore]);

  return (
    <div>
      <Navbar
        heading="FDP - Unconstrained Forecast"
        searchComponent={<ConceptSearchBar />}
        progressComponent={
          <CircularProgress
            value={percentProgress.percentage}
            toggleFunction={toggleBulkUpdateModal}
            loading={isUnconstrainedForecastProgressLoading}
          />
        }
        bulkEditComponent={
          <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
            <UploadExcelButton onClick={toggleUploadModal} />
            <BulkEditButton path="/fdp/unconstrained_forecast/bulk_edit" />
          </div>
        }
      />
      <Outlet />
      <BulkUpdate />
      {uploadModalOpen && <UploadExcelModal onClose={toggleUploadModal} />}
      {uploadValidationModalOpen && (
        <UploadExcelValidation onClose={toggleUploadValidationModal} />
      )}
    </div>
  );
};

export default observer(UnconstraintForecastHoc);
